import { styled } from 'goober';

import { modalState } from '@/state/modal.state';
import { Modal as ModalComponent } from '@/ui/modal/modal';

import { Search } from '../search/global-search/search';
import {
  searchQueryState,
  searchResultsFilterState,
} from '../search/global-search/search.state';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@/config/query-client';
import { mediaQuery } from '@/theme/setupTheme';
import { useAtom, useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

export const SearchModal = () => {
  const [modal, setModal] = useAtom(modalState);
  const setFilters = useSetAtom(searchResultsFilterState);
  const resetFilters = () => setFilters('all');
  const resetSearchQueryState = useResetAtom(searchQueryState);
  const queryClient = useQueryClient();

  if (modal?.state !== 'search') {
    return null;
  }

  const onCloseModal = () => {
    resetFilters();
    resetSearchQueryState();
    queryClient.removeQueries({
      queryKey: [QueryKey.CompaniesSearchSuggestions],
    });
    queryClient.removeQueries({
      queryKey: [QueryKey.ProjectEnrichedSearchSuggestions],
    });
    setModal(null);
  };

  return (
    <Modal closeIcon={false} onClose={onCloseModal}>
      <Search />
    </Modal>
  );
};

const Modal = styled(ModalComponent)`
  height: 720px;
  flex-direction: row;

  /* Larger than 1921px */
  ${mediaQuery('xxl', 'min')} {
    width: 1800px;
    height: 820px;
  }

  /* Up to 1920px */
  ${mediaQuery('xl', 'max')} {
    width: 1500px;
    height: 720px;
  }

  /* Up to 1440px */
  ${mediaQuery('lg', 'max')} {
    width: 1320px;
    height: 640px;
  }

  /* Up to 1200px */
  ${mediaQuery('md', 'max')} {
    width: 90%;
    height: 600px;
  }

  /* Up to 768px */
  ${mediaQuery('sm', 'max')} {
    width: 95%;
    height: 520px;
    flex-direction: column;
  }
`;
